interface Props {
  label: string;
  value: number;
  min: number;
  max: number;
  step: number;
  onChange: (v: number) => void;
  disabled?: boolean;
}

export function SliderField({ label, value, min, max, step, onChange, disabled }: Props) {
  const pct = max > min ? ((value - min) / (max - min)) * 100 : 0;
  const fill = `linear-gradient(to right, var(--primary) 0%, var(--primary-hover) ${pct}%, var(--bg-elevated) ${pct}%, var(--bg-elevated) 100%)`;
  return (
    <div className="flex flex-col gap-2.5">
      <div className="flex items-center justify-between">
        <span className="text-[12px] font-medium text-[var(--text-secondary)]">{label}</span>
        <span className="grid h-7 min-w-9 place-items-center rounded-lg bg-[var(--bg-elevated)] px-2 text-[14px] font-extrabold tabular-nums text-[var(--text-primary)]">
          {value}
        </span>
      </div>
      <div className="flex items-center gap-3">
        <input
          type="range"
          min={min}
          max={max}
          step={step}
          value={value}
          disabled={disabled}
          aria-label={label}
          onChange={(e) => onChange(Number(e.target.value))}
          className="bf-slider flex-1"
          style={{ background: fill }}
        />
      </div>
      <div className="flex justify-between text-[10px] font-medium text-[var(--text-muted)]">
        <span>{min}</span>
        <span>{max}</span>
      </div>
    </div>
  );
}
